import { restApi } from '../../../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { paginate } from '../../../../lib/loopback'
import { createQueryString } from '../../../../utils/Repository'

const queryTransform = {
  ...paginate
}

const pessoaJuridicaRepository = createRepository({
  path: 'pessoas-juridica-rf',
  restApi,
  queryTransform: {
    ...paginate
  }
})

pessoaJuridicaRepository.manualFetch = ({ solicitacaoId, cnpj }) =>
  restApi.post(`/pessoas-juridica-rf/manual-fetch/${solicitacaoId}`, {
    cnpj
  })

pessoaJuridicaRepository.list = ({ query, paginate, options } = {}) => {
  const queryString = createQueryString(query, paginate, queryTransform)
  return restApi.get('/pessoas-juridica-rf' + queryString, {}, options)
}

export default pessoaJuridicaRepository
